export const acctNoRangeFrom = {
  getMessage: (field, args) => {
    return field + ' must less than or equal To Account No.'
  },
  validate: (value, args) => {
    return !(value > args)
  }
}

export const acctNoRangeTo = {
  getMessage: (field, args) => {
    return field + ' must greater than or equal From Account No.'
  },
  validate: (value, args) => {
    return !(value < args)
  }
}
